import { IBillingInfo } from "app_services/shoppingCart/shoppingCart"
import { IHttpResponse } from "app_types/httpTypes"
import { IShoppingCarItem } from "app_types/shoppingCart/shoppingCarTypes"

export enum TransactionStatus {
  SUCCESS = 'Aprobada',
  REJECTED = 'Rechazada',
  ERROR = 'Fallida',
  IN_PROCESS = 'Por Pagar',
  CANCELLED = 'Anulada',
  REVERSED = 'Reversada',
}

export interface ITransactionGetByIdResponse extends IHttpResponse {
  transaction: ITransactionStatus
}

export interface ITransaction {
  _id?: string
  id?: string
  status?: TransactionStatus
  certificateQueue?: string
  paymentId?: string
  redirectUrl?: string
  certificateInfo?: {
    fullName: string
    docNumber: string
  }
  baseAmount?: number
  totalAmount?: number
  taxesAmount?: number
}

export interface ITransactionStatus extends Partial<Omit<ITransaction, 'certificateQueue'>> {
  certificateQueue?: {
    _id: string
    certificateSetting: {
      certificateName: string
      _id: string
    }
  },
  shoppingCartItems?: IShoppingCarItem[]
  billingInfo?: IBillingInfo
}
